import React from 'react';
import styles from './AgentTitle.css';

interface IAgentTitleProps {
  title: string;
  url?: string;
}

export function AgentTitle({ title, url }: IAgentTitleProps) {
  const TitleNameElement = url ? 'a' : 'span';

  return (
    <TitleNameElement className={styles['title']} href={url} target={'_blank'} onClick={e => e.stopPropagation()}>
      {title}
    </TitleNameElement>
  );
}
